<template>
	<div :class="[]">
		<a class="pointer" v-for="(link, index) in filteredLinks" 
		:key="index" 
		:active="link.active || select == index" 
		@click="() => onClick(link.url, index)"
			v-html="link.label"> </a>
	</div>
</template>

<script>
export default {
	props: ['links', 'click', 'select'],
	computed: {
		filteredLinks() {
			return this?.links?.filter(x => x.url) ?? []
		}
	},
	methods: {
		onClick: function (url, index) {
			this.click(url, index)
		}
	}
}
</script>